/*jslint sloppy: true*/
/*global getResponsiveBreakpoint: true, isElementInViewport: true, jQuery: true */

var Northstar = Northstar || {};

(function ($, window, document) {
  'use strict';

  // ---------------------------------------------------------------------------
  // Venue Compare Scrollable Tables - must be above scrollTable to fire first
  Northstar.scrollTableVenueCompare = {
    attach: function () {
      // console.log('Northstar.scrollTableVenueCompare loaded');

      // Create scrollable tables & set resize events
      $('.scroll-table.venue-compare').on('scrollTableCreate', Northstar.scrollTableVenueCompare.create);

    },

    create: function () {
      //console.log('scrollTableCreate');
      // Copy the scroll table header into the sticky header
      var tableWrap = $(this),
        scrollHeader = $('.scroll-table--header', tableWrap).clone(true),
        scrollSticky = $('.scroll-table--sticky', tableWrap);
      scrollSticky.append(scrollHeader);
      $('.scroll-table--sticky--scroll .table tr', tableWrap).children().not(':first-child').addClass('pad-top');
    }
  };
  // Initialize our app on document ready
  $(document).ready(Northstar.scrollTableVenueCompare.attach);


  // ---------------------------------------------------------------------------
  // Scrollable Tables
  Northstar.scrollTable = {
    speed: 300,

    attach: function () {
      // console.log('Northstar.scrollTable loaded');

      // Create scrollable tables & set resize events
      $('.scroll-table').each(Northstar.scrollTable.create);
      $(window).on('resize', function () {
        requestAnimationFrame(Northstar.scrollTable.resize);
      });

    },

    create: function () {
      var tableWrap = $(this),
        table = $('table', this),
        tableFirstCol = table.clone();

      // Check for sticky header option
      if (tableWrap[0].hasAttribute('data-sticky-header')) {
        if (!$('body').hasClass('scrolltable-sticky-processed')) {
          $(window).on('scroll load resize', function () {
            requestAnimationFrame(Northstar.scrollTable.sticky);
          });
          $('body').addClass('scrolltable-sticky-processed');
        }
        // Clone the thead to our sticky header
        var stickyHeader = table.clone();
        $('tbody', stickyHeader).remove();
        $('.scroll-table--table', tableWrap).append(stickyHeader);
        stickyHeader.wrap('<div class="scroll-table--sticky"><div class="scroll-table--sticky--scroll"></div></div>');

        // Clone the first cell to a div
        var first = $('tr > :first-child', stickyHeader).clone();
        first.insertAfter($('.scroll-table--sticky--scroll', tableWrap));
        first.wrap('<div class="scroll-table--sticky--first"></div>');
      }

      // Remove all but the first column from our clone, add classes, insert
      $('th, td', tableFirstCol).not(':first-child').remove();
      tableFirstCol.insertBefore(table);
      tableFirstCol.wrap('<div class="scroll-table--label"></div>');
      table.wrap('<div class="scroll-table--content"></div>');

       // Set rowspan and add collapse toggles
      $('.tr-collapse div', tableFirstCol).append('<a href="#" class="tr-collapse--toggle"></a>');
      $('.tr-collapse > td', table).attr('colspan', $('tbody tr', table).not('.tr-collapse').first().children().length);

      // Resize and attach events
      Northstar.scrollTable.resizeTable(null, tableWrap);
      $(table.parent()).on('scroll', Northstar.scrollTable.navUpdate);
      $('.tr-collapse--toggle').on('click', Northstar.scrollTable.toggleRows);
      $('.scroll-table--header--prev, .scroll-table--header--next', tableWrap).on('click', Northstar.scrollTable.scroll);
      tableWrap.trigger('scrollTableCreate');
    },

    navUpdate: function (e, table) {
      table = (typeof table != 'undefined') ? table : $(this);
      var tableWrap = table.parent().parent().parent(),
       tableHeader = $('.scroll-table--header', tableWrap),
       scrollContainer = $('.scroll-table--content', tableWrap),
       scrollLeft = scrollContainer[0].scrollLeft,
       scrollRight = $('.table', scrollContainer).width() - scrollContainer.width();
      if (scrollLeft > 1) {
        $('.scroll-table--header--prev', tableHeader).removeClass('disabled');
      }
      else {
        $('.scroll-table--header--prev', tableHeader).addClass('disabled');
      }
      if (scrollLeft >= scrollRight - 2) {
        $('.scroll-table--header--next', tableHeader).addClass('disabled');
      }
      else {
        $('.scroll-table--header--next', tableHeader).removeClass('disabled');
      }
      $('.scroll-table--sticky--scroll').scrollLeft(scrollLeft);
    },

    scroll: function (e) {
      e.preventDefault();
      var dir = $(this).hasClass('scroll-table--header--next') ? 1 : 0, // 0 - prev, 1 - next
        tableWrap = $(this).closest('.scroll-table'),
        scrollContainer = $('.scroll-table--content', tableWrap),
        width = $('tbody > tr', scrollContainer).not('.tr-collapse').first().children(':nth-child(2)').outerWidth(),
        scrollLeft = scrollContainer[0].scrollLeft,
        current = scrollLeft/width;
      if (dir == 1 && Math.floor(current) == current && $.isNumeric(current))
        current++;
      else if (dir == 1)
        current = Math.ceil(current);
      else if (Math.floor(current) == current && $.isNumeric(current))
        current--;
      else
        current = Math.floor(current);
      scrollContainer.animate({scrollLeft: (current * width)}, Northstar.scrollTable.speed);
    },

    resize: function () {
      $('.scroll-table').each(Northstar.scrollTable.resizeTable);
    },

    resizeTable: function (e, tableWrap) {
      tableWrap = $(tableWrap);
      var table = $('.scroll-table--content table', tableWrap),
        tableFirstCol = $('.scroll-table--label table', tableWrap);

      // Make all the rows the same height across both tables
      $('tr', table).each(function (index) {
        var maxHeight = 0,
          tableCell = $(this).children(':first-child'),
          tableFirstColCell = $('tr', tableFirstCol).eq(index).children(':first-child');
        $(this).children().css('height', '');
        tableFirstColCell.css('height', '');
        maxHeight = Math.max(maxHeight, tableCell.outerHeight());
        maxHeight = Math.max(maxHeight, tableFirstColCell.outerHeight());
        $(this).children().css('height', maxHeight);
        tableFirstColCell.css('height', maxHeight);
      });

      // Make any tr-collapse rows equal to the overall width
      $('.tr-collapse div', tableFirstCol).css('width', tableWrap.width() - 1);

      // Resize sticky header cells
      $('.scroll-table--sticky--scroll tr', tableWrap).each(function (index) {
        $(this).children().css('height', '');
        $('.scroll-table--sticky--first > *', tableWrap).css('height', '');
        var maxHeight2 = 0, maxHeight3 = 3;
        maxHeight2 = Math.max(maxHeight2, $(this).children(':first-child').outerHeight());
        maxHeight3 = Math.max(maxHeight3, $(this).children(':first-child').height());
        $(this).children().css('height', maxHeight2);

        $('.scroll-table--sticky--first > *', tableWrap).css('height', maxHeight2);
      });

      // Update nav & sticky header
      Northstar.scrollTable.navUpdate(null, table.parent());
      $('.scroll-table--sticky--scroll', tableWrap).width(tableWrap.width() - 1);
    },

    toggleRows: function (e) {
      e.preventDefault();
      var tableWrap = $(this).closest('.scroll-table'),
        trCollapse = $(this).parent().parent().parent(),
        delta = trCollapse.index();
      trCollapse.toggleClass('collapsed');
      $('.scroll-table--label tbody tr', tableWrap).each(function (index, row) {
        if (index > delta) {
          if ($(row).hasClass('tr-collapse'))
            return false;
          if (!trCollapse.hasClass('collapsed'))
            $(row).fadeIn();
          else
            $(row).hide();
        }
      });
      $('.scroll-table--content tbody tr', tableWrap).each(function (index, row) {
        if (index > delta) {
          if ($(row).hasClass('tr-collapse'))
            return false;
          if (!trCollapse.hasClass('collapsed'))
            $(row).fadeIn();
          else
            $(row).hide();
        }
      });
    },

    sticky: function (e) {
      var size = getResponsiveBreakpoint(),
        topVal = Northstar.menu.getFxdmenuH(),
        scrolly = $(window).scrollTop(),
        stickyHeader = $('.scroll-table--sticky'),
        staticHeader = $('.scroll-table--table thead'),
        tableWrap = stickyHeader.parent().parent(),
        offset = staticHeader.offset(),
        offsetTopadj = offset.top - topVal + staticHeader.outerHeight() - stickyHeader.outerHeight();

      // Smallest size, remove sticky and any position values
      if (size == 'xs' || size == 'sm') {
        stickyHeader.removeClass('enabled');
      }
      else {
        if ($('.jump-links--fixed').length) {
          scrolly += $('.jump-links--fixed').outerHeight();
          topVal += $('.jump-links--fixed').outerHeight();
        }

        if (scrolly > offsetTopadj && (scrolly + topVal) >= offset.top) {
          stickyHeader.addClass('enabled');
          stickyHeader.css({top: topVal});
          Northstar.scrollTable.resizeTable(null, tableWrap);
        }
        else {
          stickyHeader.removeClass('enabled');
        }
      }
    }
  };
  // Initialize our app on document ready
  $(document).ready(Northstar.scrollTable.attach);

}(jQuery, this, this.document));
